var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationTire = function SvgSimpleIllustrationTire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__tire_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__tire_svg__st4{fill:none;stroke:#002140;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M30.656 53.596c12.315 0 22.298-9.983 22.298-22.298S42.97 9 30.656 9C18.341 9 8.358 18.983 8.358 31.298s9.983 22.298 22.298 22.298z",
    style: {
      fill: "#28736d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.722 10.039S53.377 14.592 52.338 33.2c-.91 10.929-9.627 16.784-11.321 17.564-1.69.78-12.361 6.376-23.161-1.173l-4.423-4.165s-1.91.235-2.082 1.69l-.172 1.455s-2.82 2.188-2.431 3.749c.392 1.561 6.635 5.726 21.337 5.855 14.702.129 24.592-3.122 25.894-4.816 1.302-1.69.055-3.474-.651-3.643 0 0-1.431-2.863-2.341-3.251 0 0 5.855-7.416 5.855-16.914 0-9.498-10.278-19.776-20.69-20.298 0 0-2.341-.522-1.431.78l.001.006z",
    style: {
      fill: "#4ba6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.565 41.659c6.253 0 11.321-5.069 11.321-11.321 0-6.253-5.069-11.321-11.321-11.321-6.253 0-11.321 5.069-11.321 11.321-.001 6.252 5.068 11.321 11.321 11.321z",
    style: {
      fill: "#134038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.149 33.851a3.447 3.447 0 1 0 0-6.893 3.447 3.447 0 0 0 0 6.893z",
    style: {
      fill: "#d18000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.954 49.682c-5.882-3.976-9.753-10.706-9.753-18.341 0-12.216 9.902-22.121 22.121-22.121s22.121 9.902 22.121 22.121-9.902 22.121-22.121 22.121",
    className: "simple-illustration__tire_svg__st4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.365 9.247s4.51-.024 5.2-.024c12.215 0 22.121 9.902 22.121 22.121 0 8.486-4.78 15.855-11.792 19.564M12.938 45.376c-.518.4-1.043.808-1.416 1.345-.372.537-.565 1.239-.349 1.859.169.486.573.863 1.027 1.11.455.247.961.372 1.459.502",
    className: "simple-illustration__tire_svg__st4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.859 46.353c.518.4 1.043.808 1.416 1.345.373.537.565 1.239.349 1.859-.169.486-.572.863-1.027 1.11-.455.243-.961.373-1.459.502",
    className: "simple-illustration__tire_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.761 49.38c1.22.757 1.898 1.584 1.898 2.455 0 3.486-10.808 6.31-24.137 6.31s-24.137-2.823-24.137-6.31c0-1.051.984-2.043 2.722-2.914M29.844 41.752c6.253 0 11.321-5.069 11.321-11.321S36.096 19.11 29.844 19.11c-6.253 0-11.322 5.069-11.322 11.322s5.069 11.32 11.322 11.32z",
    className: "simple-illustration__tire_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.063 33.851a3.514 3.514 0 1 0 0-7.027 3.514 3.514 0 0 0 0 7.027z",
    className: "simple-illustration__tire_svg__st4"
  })));
};
export default SvgSimpleIllustrationTire;